webpackJsonp([7],{

/***/ "./src/pages/cart/cart-quantity-selector.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _dropdown = __webpack_require__("./src/components/dropdown/dropdown.js");

var _dropdown2 = _interopRequireDefault(_dropdown);

var _cart = __webpack_require__("./src/components/cart/cart.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CartQuantitySelector = function () {
  function CartQuantitySelector() {
    _classCallCheck(this, CartQuantitySelector);
  }

  /**
   * When the quanity counter in the cart changes, refresh the page by submitting
   * the form the page is wrapped in.
   * @static
   */
  CartQuantitySelector.initializeAll = function initializeAll() {
    var dropdowns = Array.from(document.querySelectorAll('.odo-dropdown.cart-b')).map(function (element) {
      return new _dropdown2.default(element);
    });

    var hasQuantityChanged = false;

    dropdowns.forEach(function (dropdown, i) {
      var id = parseInt(dropdown.element.closest('[data-product-id]').dataset.productId, 10);
      dropdown.productTotal = (0, _cart.getProductTotal)(Shopify.cart, id);
      var currentQuantity = parseInt(dropdown.select.dataset.quantity, 10);
      dropdown.maxQuantity = parseInt(dropdown.select.dataset.max, 10);
      if (dropdown.select.dataset.productType == 'Caavo') {

        // If they somehow added more than allow, remove all of this item.
        if (dropdown.productTotal > window.maxCaavos) {
          window.location = '/cart/change?line=' + (i + 1) + '&quantity=' + window.maxCaavos;
          return;
        }

        // When the page loads, check if the user has added more items to their cart
        // than the maximum allows.
        if (currentQuantity > window.maxCaavos) {
          dropdown.value = window.maxCaavos;
          hasQuantityChanged = true;
        }
      }
      // else {
      //   if (dropdown.productTotal > window.maxProduct) {
      //     window.location = `/cart/change?line=${i + 1}&quantity=`+window.maxProduct;
      //     return;
      //   }
      // }

      dropdown.on(_dropdown2.default.EventType.CHANGE, CartQuantitySelector.submit);

      var totDisc = parseInt($("#cart-disc-amount").val());
      var discMsg = "";
      if (totDisc > 0) {
        discMsg = "You Saved $" + totDisc / 100 + " By Buying More!";
        $("#cart-disc-msg").show();
      } else {
        $("#cart-disc-msg").hide();
      }
      $(".cart-disc-msg-text").html(discMsg);
    });

    // If we have changed the quantity of any items, submit the page again to refresh
    // with the correct values / prices.
    if (hasQuantityChanged) {
      CartQuantitySelector.submit();
      return;
    }

    // Disable quantity values which would add more to the users cart than the
    // maximum amount.
    dropdowns.forEach(function (dropdown) {
      var amountAvailableToAdd = dropdown.maxQuantity - dropdown.productTotal;
      var dropdownQuantity = parseInt(dropdown.value, 10);
      var max = dropdown.productTotal >= dropdown.maxQuantity ? dropdownQuantity : dropdownQuantity + amountAvailableToAdd;

      CartQuantitySelector.disableHigherOptions(dropdown, max);
    });
  };

  CartQuantitySelector.disableHigherOptions = function disableHigherOptions(dropdown, max) {
    dropdown.getNativeOptions().forEach(function (option) {
      var optionValue = parseInt(option.value, 10);
      var willDisable = optionValue > max;
      dropdown.toggleOptionByValue(option.value, willDisable);
    });
  };

  CartQuantitySelector.submit = function submit() {
    document.querySelector('form.cart').submit();
  };

  return CartQuantitySelector;
}();

CartQuantitySelector.initializeAll();

exports.default = CartQuantitySelector;

/***/ }),

/***/ "./src/pages/cart/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./src/pages/cart/index.scss");

__webpack_require__("./src/pages/cart/cart-quantity-selector.js");

/***/ }),

/***/ "./src/pages/cart/index.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["./src/pages/cart/index.js"]);